import '../../styles/SelectionMenu.css';
import React, { useEffect, useMemo, useState } from 'react';
import { attributes, styles, selectedToStyle, colorStyles } from './PropsAvatar';
import closeIcon from '../avatar/icons/closeIcon.png';
import { EditDisplayAvatar } from './EditAvatarDisplay';

export const SelectionMenu = ({ counter, setCounter, hidden, setHidden, setHideOnDisplay, setCustomize, props: [avatarStyleProps, setAvatarStyleProps, avatarColorProps, setAvatarColorProps] }) => {
    const [hideArrows, setHideArrows] = useState(true);
    const [styleIndex, setStyleIndex] = useState(null);
    const [selected, setSelected] = useState(false);
    const [toPickFrom, setToPickFrom] = useState([]);
    const [hideMenuBar, setHideMenuBar] = useState(false);
    const [colorStyleID, setColorStyleID] = useState(-1);
    const [listOfColors, setListOfColors] = useState(null);

    useEffect(() => {
        setHideOnDisplay(true);
    });

    useMemo(() => {
        if (styleIndex) {
            avatarStyleProps[selectedToStyle[styleIndex]] = toPickFrom[counter];
        }
    }, [counter]);

    function handleSelected(e) {
        const index = e.target.id || e.target.parentElement.id;
        setHideArrows(!hideArrows);
        setSelected(true);
        setStyleIndex(index);
        setHideMenuBar(true);
        setHideOnDisplay(true);
        setColorStyleID(attributes.options[index].colorOptions);
        const newList = styles[index].filter(elem => elem !== avatarStyleProps[selectedToStyle[index]]);
        newList.unshift(avatarStyleProps[selectedToStyle[index]]);
        setToPickFrom(newList);
        setListOfColors(colorStyles[attributes.options[index].colorOptions]);
    }

    function handleSave(styleNum) {
        const key = selectedToStyle[styleIndex];
        const newProps = { ...avatarStyleProps };
        newProps[key] = toPickFrom[styleNum];
        setAvatarStyleProps(newProps);
        handleClose();
    }

    function handleClose(e) {
        setHidden(!hidden);
        setHideArrows(!hideArrows);
        setCounter(0);
        setSelected(false);
        setHideOnDisplay(false);
        setCustomize(false);
    }

    function handleBack(e) {
        setHideMenuBar(false);
        setColorStyleID(-1);
        setHideArrows(!hideArrows);
    }

    return (
        <>
            <EditDisplayAvatar
                props={[avatarStyleProps, setAvatarStyleProps, avatarColorProps, setAvatarColorProps]}
                setCounter={setCounter}
                toPickFrom={toPickFrom}
                hideArrows={hideArrows}
                selected={selected}
                counter={counter}
                colorStyleID={colorStyleID}
                listOfColors={listOfColors}
            />
            {selected & hideMenuBar
                ? <div className='end-buttons flex gap-12 z-3'>
                    <button
                        className='avatarButton cursor-pointer bg-gradient-to-br from-blueShade1 to-blueShade2 text-center justify-around no-underline whitespace-nowrap outline-none touch-manipulation text-white transition duration-200 select-none font-medium text-base px-4 py-2.5 rounded-xl'
                        onClick={(e) => {
                            handleSave(counter);
                        }}>
                        Save
                    </button>
                    <button
                        className='avatarButton cursor-pointer bg-gradient-to-br from-blueShade1 to-blueShade2 text-center justify-around no-underline whitespace-nowrap outline-none touch-manipulation text-white transition duration-200 select-none font-medium text-base px-4 py-2.5 rounded-xl'
                        onClick={ (e) => {
                            handleBack(e);
                        }}>
                        Back
                    </button>
                </div>
                : null
            }
            {!hideMenuBar
                ? <>
                    <div className='outer-menubar relative bg-black rounded-cm h-20 xs:w-76 sm:w-92 md:w-92 w-92 items-center justify-center flex'>
                        <div className='menubar relative bg-black items-center justify-center overflow-y-hidden overflow-x-scroll h-20 rounded-cm whitespace-nowrap w-64 xs:w-50 sm:w-64 md:w-68 pt-4 z-3 ml-4'>
                            {attributes.options.map(
                                (elem) => {
                                    return (
                                        <div key={elem.id} className='circle inline-block justify-center items-center bg-gradient-to-br from-iconsGrey to-black align-top p-2.5 rounded-50 mx-4'>
                                            <img key={elem.name} src={elem.icon} id={elem.id} className='icons text-white w-6 h-6 cursor-pointer' onClick={(e) => handleSelected(e)}>
                                            </img>
                                        </div>
                                    );
                                },
                            )}
                        </div>
                        <img src={closeIcon} className='close relative border-50 cursor-pointer w-4 h-4 bottom-6 border-solid border-1 outline-none border-black z-3 right-0 sm:mt-2 sm:ml-2 md:mt-2 md:ml-2 lg:mt-2 lg:ml-4'
                            onClick={(e) => {
                                handleClose(e);
                            }}>
                        </img>
                    </div>
                </>
                : null
            }
        </>
    );
};
